import type { Job } from '../../../src/types.ts';
import { filterFlights, type MaxStops } from './flights.ts';
import { fmtMinutes, splitLegs } from './itinerary.ts';

function cell(v: unknown): string {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Every fare of a month search as CSV rows, one per fare, for a spreadsheet. */
export function toCsv(job: Job, maxStops: MaxStops): string {
  const head = ['date', 'return', 'price', 'currency', 'airline', 'flights', 'route', 'stops', 'out_duration', 'return_duration', 'depart', 'arrive', 'provider', 'refundable'];
  const rows = [head.join(',')];
  for (const day of job.days) {
    for (const f of [...filterFlights(day.flights, maxStops)].sort((a, b) => a.price - b.price)) {
      const legs = splitLegs(f);
      rows.push(
        [
          day.date,
          f.returnDate ?? '',
          f.price,
          f.currency,
          f.airline,
          f.segments.map((s) => s.flightNo).filter(Boolean).join(' '),
          `${f.originCode}-${f.destinationCode}`,
          f.stops,
          fmtMinutes(legs[0]?.totalMinutes),
          fmtMinutes(legs[1]?.totalMinutes),
          f.departTime ?? '',
          f.arriveTime ?? '',
          f.provider,
          f.refundable == null ? '' : f.refundable ? 'yes' : 'no',
        ]
          .map(cell)
          .join(','),
      );
    }
  }
  return rows.join('\n');
}

export function exportCsv(job: Job, maxStops: MaxStops): void {
  const p = job.params;
  const blob = new Blob([toCsv(job, maxStops)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `etravel-${p.origin}-${p.destination}-${p.year}-${String(p.month).padStart(2, '0')}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
